export const charges = {
  BEN: 'BEN',
  OUR: 'OUR',
  SHA: 'SHA'
};

export const chargeOptions = Object.values(charges);

export const domestic = 'domestic';
export const international = 'international';
export const bankCodeListOptions: (typeof domestic | typeof international)[] = [
  domestic,
  international
];

export const WIRE_BANK_CODE_CONFIG = {
  DOMESTIC: 'Domestic',
  INTERNATIONAL: 'International',
  BOTH: 'Both'
} as const;

export const usdCurrencyType = [
  {
    id: 'USD',
    name: `USD - US Dollar`,
    currency: 'USD',
    currencyName: 'US Dollar',
    exchangeRate: 1,
    path: []
  }
];

export const wirePaymentTypes = [
  {
    credit: false,
    debit: false,
    hasAddendum: false,
    offsetLevel: null,
    code: 'Domestic',
    description: 'Domestic Wire',
    uniqueId: null
  },
  {
    credit: false,
    debit: false,
    hasAddendum: false,
    offsetLevel: null,
    code: 'International',
    description: 'International Wire',
    uniqueId: null
  }
];
